package dev.wyns.ventrova.ui.cupertino

import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Typography
import androidx.compose.material3.lightColorScheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.ui.text.font.FontFamily
import dev.wyns.ventrova.ui.components.LocalPlatformControls
import dev.wyns.ventrova.ui.components.LocalSkeletonStyle
import dev.wyns.ventrova.ui.components.PlatformControls
import dev.wyns.ventrova.ui.components.SkeletonStyle
import dev.wyns.ventrova.ui.map.MapDecorations
import dev.wyns.ventrova.ui.map.MarkerStyle
import dev.wyns.ventrova.ui.theme.ProvideVentrovaFonts
import dev.wyns.ventrova.ui.theme.VentrovaColors
import dev.wyns.ventrova.ui.theme.withFontFamily

/**
 * What differs between hosts of the iOS design: native iOS uses UIKit controls and the system font,
 * the web imitation draws the controls and bundles a font.
 */
class CupertinoStyle(
    val controls: PlatformControls,
    val bodyFont: @Composable () -> FontFamily,
)

internal val CupertinoDecorations = MapDecorations(
    markerStyle = MarkerStyle.Ios,
    locationColor = VentrovaColors.LocationIos,
    radiusRingColor = VentrovaColors.Ink.copy(alpha = 0.45f),
    radiusRingFill = VentrovaColors.Ink.copy(alpha = 0.045f),
    radiusRingDashed = true,
)

/** Theme for every piece of the iOS design's Compose content. */
@Composable
internal fun CupertinoTheme(model: CupertinoModel, content: @Composable () -> Unit) {
    val body = model.style.bodyFont()
    MaterialTheme(
        colorScheme = lightColorScheme(primary = VentrovaColors.Ink, surface = VentrovaColors.Paper, onSurface = VentrovaColors.Ink),
        typography = Typography().withFontFamily(body),
    ) {
        ProvideVentrovaFonts(body = body) {
            CompositionLocalProvider(
                LocalPlatformControls provides model.style.controls,
                LocalSkeletonStyle provides SkeletonStyle.Placeholder,
                content = content,
            )
        }
    }
}
